import { useState, useEffect } from "react";

export const useNewTimer = (initialTime: number) => {
	const [isRunning, setIsRunning] = useState(false);
	const [elapsedTime, setElapsedTime] = useState(initialTime);
	const [startTime, setStartTime] = useState(initialTime);
	const [dateStart, setDateStart] = useState(new Date());

	useEffect(
		() => {
			let interval: NodeJS.Timeout;
			if (isRunning) {
				interval = setInterval(
					() => {
						const dateNow = new Date();
						setElapsedTime(startTime + (dateNow.getTime() / 1000 - dateStart.getTime() / 1000));
					},
					1000
				);
			}
			return () => clearInterval(interval);
		},
		[isRunning]
	);

	return {
		isRunning,
		setIsRunning,
		elapsedTime,
		setElapsedTime,
		startTime,
		setStartTime,
		dateStart,
		setDateStart
	};
};

export const useNewStopwatch = (initialTime: number) => {
	const [laps, setLaps] = useState<number[]>([]);
	const {isRunning, setIsRunning, elapsedTime, setElapsedTime, startTime, setStartTime, dateStart, setDateStart} = useNewTimer(initialTime);

	const handleReset = () => {
		setIsRunning(false);
		setElapsedTime(0);
		setLaps([]);
	};

	const handleAddLap = () => {
		const prevTotal =
			laps.length > 0 ? laps.reduce((acc, curr) => acc + curr, 0) : 0;
		const currentLap = laps.length > 0 ? elapsedTime - prevTotal : elapsedTime;
		isRunning && setLaps([...laps, currentLap]);
	};

	return {
		// elapsedTime: elapsedTime.toFixed(1),
		elapsedTime: new Date(elapsedTime * 1000).toISOString().substr(11, 8),
		laps,
		addLap: () => handleAddLap(),
		resetTimer: () => handleReset(),
		startTimer: () => {
			setIsRunning(true);
			setDateStart(new Date());
		},
		stopTimer: () => {
			setIsRunning(false);
			setStartTime(elapsedTime);
		},
		isRunning
	};
};
